export default {"src":"/_next/static/media/playButton.05231f7b.svg","height":112,"width":112};